import RestModule from "../RestModule";

export default new RestModule("trailers", {});
